<template>
  <div>
      <img style="position:fixed;top:50%;left:50%;transform: translate(-50%, -50%);" src="./assets/logo_full.png">
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue